import { h } from 'preact';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css';
import Image from '../utils/image';
import LongArrowRight from '../utils/icon/long-arrow-right.svg';
import LongArrowLeft from '../utils/icon/long-arrow-left.svg';

const ColumnInnerContentSwiper = ({ productsList, handleItemChange }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (
      swiperInstance &&
      prevRef.current &&
      nextRef.current &&
      swiperInstance.params.navigation
    ) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.destroy();
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const handleSlideChange = (swiper) => {
    const target = swiper.slides[swiper.activeIndex]
    handleItemChange(target.dataset.variantId)
  }

  return (
    <div className='w-full relative'>
      <div className="absolute z-[4] top-[50%] w-full flex justify-between">
        <button ref={prevRef} className="hidden laptop:block w-[33px] bg-transparent border-0">
          <LongArrowLeft />
        </button>
        <button ref={nextRef} className="hidden laptop:block w-[33px] bg-transparent border-0">
          <LongArrowRight />
        </button>
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation={false}
        pagination={{ clickable: true }}
        onSwiper={setSwiperInstance}
        className="w-full"
        onSlideChange={handleSlideChange}
      >
        {productsList.map(({ title, price, image, variant_id: variantId }) => (
          <SwiperSlide key={variantId} data-variant-id={variantId} className='text-center bg-neutral'>
            <Image classes={clsx(
              'max-w-[65%] laptop:max-w-full laptop:max-h-[470px] inline-block',
              image.includes('white-background') && 'mix-blend-multiply'
            )}
            src={image} />
              <p className='pt-[38px] v-paragraph'>{title}</p>
              <p className='pt-[8px] pb-[20px] v-paragraph text-[13px]'>{price}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ColumnInnerContentSwiper;
